import React ,{useState, useEffect} from 'react';
export default function News(){
    const [news,setNews] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const url = "https://cms.lizakhan.com/items/news"

    useEffect(()=>{
	fetch(url).then(res => res.json()).then(result => {
	    setLoading(true);
	    console.log(result.data);
	    setNews(result.data);
	}).catch(error =>{
	    setLoading(true);
	    setError(error);
	})
    }, []);
    if(error){
	return <div> Error: {error}</div>;
    } else if(!loading){
	return <div>Loading ...</div>;
    } else{
	return(<main>
		   <div class="px-4 pt-5 my-5 text-left">
		       {news &&  news.map(item =>
			   <div className="container px-4 py-5">
			       <h1 class="display-4 fw-bold">{item.title}</h1>
			       <h4 class="lh-1">Published: {new Date(item.dateTime).toDateString()}</h4>
			       <div class="mx-auto">
				   <p class="lead mb-4">Quickly design and customize responsive mobile-first sites with Bootstrap, the world’s most popular front-end open source toolkit, featuring Sass variables and mixins, responsive grid system, extensive prebuilt components, and powerful JavaScript plugins.</p>
			       </div>
			       <div class="overflow-hidden" style={{maxHeight: "30vh"}}>
				   <div class="container px-5">
				       <img style={{float:"right"}} src={"https://cms.lizakhan.com/assets/"+item.image} class="img-fluid border rounded-3 shadow-lg mb-4" alt="Example image" width="700" height="500" loading="lazy" />
				   </div>
				   <p>{item.body}</p>
			       </div>
			   </div>
		       )}
		   </div>
	       </main>
	      )
    }
}
